<template>
  <v-card
    :style="
      'width: 100% !important; height: 100% !important; overflow: hidden' +
      backgroundColor
    "
  >
    <v-row
      :style="`${
        !horizontalTitle ? 'display: grid; align-items: start;' : ''
      } height: 100%; margin: 0; `"
    >
      <v-col
        :style="`${
          horizontalTitle
            ? 'height: 100%; align-items: center;'
            : 'align-content: top; align-items: top;'
        } ${textColor} ${titleBackground}; 
            display: flex;
            justify-content: left;`"
      >
        <div>
          <v-row no-gutters>
            <span
              :style="`width: 100%; font-size: ${fontStyle.title.size}rem`"
              :class="fontStyle.title.weight + ' text-left'"
            >
              {{ module.name === null ? "" : module.title }}
            </span>
          </v-row>
          <v-row no-gutters>
            <span
              :style="`width: 100%; font-size: ${
                fontStyle.title.size * 0.2 + 0.6
              }rem`"
              :class="fontStyle.title.weight + ' text-left'"
              >{{ date }}</span
            >
          </v-row>
        </div>
      </v-col>
      <v-col
        :cols="horizontalTitle ? 6 : 12"
        :style="`
            padding: 0;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            ${horizontalTitle ? 'height: 100%;' : ''}`"
      >
        <div>
          <v-row no-gutters>
            <span
              :class="`text-center
               ${fontStyle.value.weight}`"
              :style="
                'width: 100%;' +
                textColor +
                ';font-size: ' +
                fontStyle.value.size +
                'rem'
              "
            >
              {{ getLabel }}

              <v-icon
                :medium="horizontalTitle"
                :large="!horizontalTitle"
                :style="textColor"
                v-if="metaHasKey(module.meta, MetaEnum.ICON)"
                >{{ getMeta(module.meta, MetaEnum.ICON).value }}</v-icon
              >
              <v-icon
                :medium="horizontalTitle"
                :large="!horizontalTitle && fontStyle.value.size < 2.8"
                :x-large="!horizontalTitle && fontStyle.value.size > 2.8"
                size=""
                :color="getTrendColor"
                v-if="!metaHasKey(module.meta, MetaEnum.HIDETRENDICON)"
                >{{ getTrendIcon }}</v-icon
              >
            </span>
          </v-row>
          <v-row no-gutters align="start">
            <span
              class="text-center"
              :style="
                'width: 100%;' +
                textColor +
                ';font-size: ' +
                (fontStyle.value.size * 0.2 + 0.5) +
                'rem'
              "
              v-if="!metaHasKey(module.meta, MetaEnum.SINGLEHIDENODEINFO)"
            >
              {{ `${name} - ${keyLabel}` }}
            </span>
          </v-row>
        </div>
        <div v-if="hasSparkline" class="d-block mt-2" style="width: 100%">
          <sparkline
            :sparkline-data="sparklineData"
            :color="sparkLineColor"
            :label-color="sparkLineLabelColor"
          />
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Meta from "@/_helpers/ModuleMeta";
import FontMeta from "@/_helpers/FontMeta";
import Sparkline from "@/components/chart/Sparkline.vue";

export default {
  name: "ModuleSingle",

  components: { Sparkline },
  mixins: [Meta],

  data() {
    return {
      date: "N/A",
      posTrend: null,
      tdata: 0.0,
      prevVal: null,

      backgroundColor: "",
      titleBackground: ";background-color: transparent;",
      textColor: "",
      fontStyle: {
        title: { size: 1.17, weight: "font-weight-bold" },
        value: { size: 2.125, weight: "font-weight-regular" },
      },

      keyLabel: "",
      name: "",

      horizontalTitle: false,
      sparklineData: [],
    };
  },

  props: ["module", "timerTick", "fakeData"],

  methods: {
    ...mapActions("tag", ["getKeyLabel"]),
    ...mapActions("tagData", { getData: "getTagDataWithMetrics" }),

    async loadData() {
      let limit = 2;

      if (this.hasSparkline) {
        // Construct the sparkline
        limit = 10;
      }

      let fetched = await this.getData({
        metrics: {
          tag: this.module.tag.deveui,
          key: this.module.key,
          limit: limit,
        },
      });

      let d;
      if (fetched.length > 2) {
        d = fetched.slice(fetched.length - 2, fetched.length);
        this.sparklineData = fetched;
      } else d = fetched;

      // Check if rounding is defined in module meta, default to 3 digits
      let digits = this.getMeta(
        this.module.meta,
        this.MetaEnum.DECIMAL_ROUNDING
      );

      // Get tag name and key
      this.name = this.module.tag.name;
      this.keyLabel = this.keyLabel ? this.keyLabel : this.module.key;

      // Make sure rounding is a valid number and reasonable
      digits = digits != null && digits.value <= 6 ? digits.value : 3;

      // Check if key has more than one value otherwise use the first one
      var val = "NaN";
      if (d[1] !== undefined) {
        this.prevVal = +parseFloat(d[0].value).toFixed(digits);
        this.tdata = +parseFloat(d[1].value).toFixed(digits);
        this.date = this.humanDate(d[1].createdAt);
        val = d[1].value;
      } else {
        this.tdata = +parseFloat(d[0].value).toFixed(digits);
        this.date = this.humanDate(d[0].createdAt);
        val = d[0].value;
      }

      if (!this.tdata) this.tdata = val;
    },

    async loadFakeData() {
      let d = 21.21879;
      let digits = this.getMeta(
        this.module.meta,
        this.MetaEnum.DECIMAL_ROUNDING
      );

      this.sparklineData = [
        { value: 20 },
        { value: 21 },
        { value: 18 },
        { value: 19 },
        { value: 11 },
        { value: 21 },
        { value: 20 },
        { value: 19 },
        { value: 22 },
        { value: 20 },
      ];

      digits = digits != null && digits.value <= 6 ? digits.value : 3;

      this.prevVal = +parseFloat(23).toFixed(digits);
      this.tdata = +parseFloat(d).toFixed(digits);
      this.date = this.humanDate(Date.now());
    },

    setStyles() {
      if (this.module && this.module.meta) {
        this.backgroundColor = "";
        this.titleBackground = ";background-color: transparent;";
        this.textColor = "";
        for (let i in this.module.meta) {
          var currentMeta = this.module.meta[i];
          if (currentMeta.key == "so_style_meta_singel_background")
            this.backgroundColor = ";background-color: " + currentMeta.content;

          if (currentMeta.key == "so_style_meta_singel_textcolor")
            this.textColor = ";color: " + currentMeta.content;

          if (currentMeta.key == "so_style_meta_singel_title_background")
            this.titleBackground = ";background-color: " + currentMeta.content;

          if (currentMeta.key == "so_horizontel_single_title")
            this.horizontalTitle = true;

          if (currentMeta.key == "so_font_style_large") {
            if (currentMeta.valueMatch == FontMeta.types.title.value) {
              this.fontStyle.title.size = currentMeta.value;
              this.fontStyle.title.weight = currentMeta.content;
            } else if (currentMeta.valueMatch == FontMeta.types.value.value) {
              this.fontStyle.value.size = currentMeta.value;
              this.fontStyle.value.weight = currentMeta.content;
            }
          }
        }
      }
    },
  },

  computed: {
    ...mapState("tagData", ["tagData"]),
    ...mapState("tag", ["currentLabel"]),

    MetaEnum() {
      return Meta.Enum;
    },

    getLabel() {
      // Check if the type is named value
      if (this.module.meta) {
        for (let i = 0; i < this.module.meta.length; i++) {
          if (parseFloat(this.module.meta[i].valueMatch) == this.tdata)
            return this.module.meta[i].value;
        }

        let prefix = this.getMeta(this.module.meta, Meta.Enum.PREFIX);
        let suffix = this.getMeta(this.module.meta, Meta.Enum.SUFIX);
        let str = [];
        if (prefix) str.push(prefix.value);
        str.push(this.tdata);
        if (suffix) str.push(suffix.value);

        return str.join(" ");
      }

      return this.tdata;
    },

    getTrendColor() {
      let vNow = +parseFloat(this.tdata);
      let vPrev = +parseFloat(this.prevVal);

      if (vNow > vPrev) return "green";
      else if (vNow < vPrev) return "red";
      else return "yellow";
    },

    getTrendIcon() {
      let vNow = +parseFloat(this.tdata);
      let vPrev = +parseFloat(this.prevVal);

      if (vNow > vPrev) return "mdi-trending-up";
      else if (vNow < vPrev) return "mdi-trending-down";
      else return "mdi-trending-neutral";
    },

    hasSparkline() {
      if (this.module.meta) {
        let sparkline = this.getMeta(
          this.module.meta,
          Meta.Enum.SINGLESPARKLINE
        );

        return sparkline == null ? false : true;
      }
      return false;
    },

    sparkLineColor() {
      let result = this.getMeta(
        this.module.meta,
        "so_style_meta_single_sparkline_color"
      );

      if (result == null) return "default";

      return result.content;
    },

    sparkLineLabelColor() {
      let result = this.getMeta(
        this.module.meta,
        "so_style_meta_single_sparkline_label_color"
      );
      if (result == null) return "default";

      return result.content;
    },
  },

  async mounted() {
    if (!this.fakeData) {
      this.keyLabel = await this.getKeyLabel({
        tagId: this.module.tag.deveui,
        key: this.module.key,
      });

      await this.loadData();
    } else await this.loadFakeData();

    this.setStyles();
  },

  watch: {
    async timerTick() {
      await this.loadData();
      this.setStyles();
    },

    async module(val, oldVal) {
      if (val != oldVal) {
        if (this.fakeData) {
          await this.loadFakeData();
          this.setStyles();
        }
      }
    },
  },
};
</script>

<style scoped>
.date-bottom {
  bottom: 0;
  position: absolute;
}
</style>
